var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", [
    _c("div", { staticClass: "fv-app" }, [
      _c("div", { staticClass: "fv-top" }, [_c("topbar")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row mr-0", style: { height: _vm.height + "px" } },
        [
          _c(
            "div",
            { staticClass: "col-3 fv-siderbar m-0 p-0" },
            [_c("sidebar")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-9 m-0 p-0 fv-content" },
            [_c("router-view")],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 